import React from 'react'

export default function CheckIn() {
  return (
    <div>
      
    </div>
  )
}
